<div class="container">

  <div class="attrContainer">
    <div
      *ngIf="loadingIndicator || isFeatureDisabled"
      class="cw-dialog-status cw-signature-preview-signature"
      style="padding: 25px 120px"
    >
      <div class="saving-text" *ngIf="!isFeatureDisabled">
        <div>Getting User Attributes...</div>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
      <div class="feature-disabled-text" *ngIf="isFeatureDisabled">
        Custom Fields is not enabled for your organisation. Please contact your Crossware
        administrator to enable this feature.<br />
        Learn more about
        <a href="https://support.crossware365.com/microsoft-365/features/fields/configuring-custom-fields" target="_blank" rel="noopener noreferrer"
          >Configuring Custom Fields</a>.
      </div>
    </div>
    <div>
      <div *ngIf="!loadingIndicator && !isFeatureDisabled">
        <div style="text-align: left; font-size: 13px; padding-top: 20px; padding-left: 70px; padding-right: 120px">
          <p style="font-size: 20px; font-weight: 500; margin-bottom: 8px;">
            Manage Your Signature Information
          </p>
          <p style="margin-top: 0;">
            The details below were selected by your admin for you to edit and will appear in your email signature. You can update these fields at any time, but your admin may lock or override them.
          </p>
        </div>

        <div
          style="padding-top: 20px; padding-bottom: 20px; padding-left: 70px; padding-right: 50px"
        >
          <div *ngIf="noEditableFieldsMessage" style="text-align: center; padding: 20px 0;">
            <p style="font-size: 16px; color: #333; font-weight: 500;">
              {{ noEditableFieldsMessage }}
            </p>
          </div>
          <form *ngIf="!noEditableFieldsMessage" id="customAttrform" [formGroup]="userForm" autocomplete="off">
            <div *ngFor="let field of formFields; let i = index">
              <div class="form-group" *ngIf="field.isMatched">
                <label
                  [attr.for]="field.editable ? field.controlKey + '_FieldValue' : null"
                  [ngClass]="{ 'disabled-label': !field.editable }"
                  [matTooltip]="
                    !field.editable ? 'Editing not allowed. Contact administrator.' : field.tooltip
                  "
                  [title]="field.lookUpName"
                >
                  <strong
                    [ngClass]="{
                      highlight: field.errorMessage === 'highlight',
                      'lightgray-text': !field.editable,
                    }"
                    >{{ field.fieldName }}</strong
                  >
                </label>
                <div class="input-group">
                  <input
                    type="hidden"
                    [id]="field.controlKey + '_FieldName'"
                    [formControlName]="field.controlKey + '_FieldName'"
                  />
                  <ng-container *ngIf="isSelectionField(field); else textInput">
                    <mat-form-field class="selection-field" appearance="outline">
                      <mat-select
                        [formControlName]="field.controlKey + '_FieldValue'"
                        [placeholder]="getPlaceholder(field)"
                        [compareWith]="compareDropdownValues"
                        [disabled]="!field.editable"
                        [ngClass]="{
                          'lightgray-text': !field.editable,
                          'disabled-field': !field.editable
                        }"
                        [ngStyle]="{ color: !field.editable ? 'lightgray' : (isDefaultOrEntraValue(field) ? 'rgba(0, 0, 0, 0.5)' : 'inherit') }"
                        [matTooltip]="
                          !field.editable
                            ? 'Editing not allowed. Contact administrator.'
                            : field.tooltip
                        "
                        [matTooltipPosition]="'above'"
                      >
                        <mat-select-trigger>
                          <span
                            *ngIf="isDropdownUnsetSelected(field); else dropdownSelectedValue"
                            class="dropdown-unset-text dropdown-unset-text--compact"
                          >
                            Not set
                          </span>
                          <ng-template #dropdownSelectedValue>
                            {{ getDropdownDisplayValue(field) }}
                          </ng-template>
                        </mat-select-trigger>
                        <mat-option
                          *ngIf="field.editable && showPlaceholderDropdownOption(field)"
                          [value]="dropdownUnsetValue"
                          class="dropdown-unset-option"
                        >
                          <span class="dropdown-unset-text">Not set</span>
                        </mat-option>
                        <mat-option
                          *ngIf="field.editable && showEmptyDropdownOption(field)"
                          [value]="''"
                          class="dropdown-unset-option"
                        >
                          <span class="dropdown-unset-text">Not set</span>
                        </mat-option>
                        <mat-option *ngFor="let option of field.allowedValues" [value]="option">
                          {{ option }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-container>
                  <ng-template #textInput>
                    <input
                      [id]="field.controlKey + '_FieldValue'"
                      [formControlName]="field.controlKey + '_FieldValue'"
                      class="form-control"
                      [attr.disabled]="!field.editable ? true : null"
                      [placeholder]="getPlaceholder(field)"
                      [ngClass]="{
                        error: field.errorMessage === 'error',
                        'lightgray-text': !field.editable,
                        'disabled-field': !field.editable
                      }"
                      [ngStyle]="{ color: !field.editable ? 'lightgray' : (isDefaultOrEntraValue(field) ? 'rgba(0, 0, 0, 0.5)' : 'inherit') }"
                      [matTooltip]="
                        !field.editable
                          ? 'Editing not allowed. Contact administrator.'
                          : field.tooltip
                      "
                      [matTooltipPosition]="'above'"
                      autocomplete="off"
                      matInput
                      (input)="onTextInput(field.controlKey)"
                      (blur)="onInputBlur(field.controlKey)"
                    />
                  </ng-template>
                  <button
                    type="button"
                    class="refresh-btn"
                    (click)="onRefresh(field.controlKey)"
                    [matTooltip]="
                      !field.editable
                        ? 'Editing not allowed. Contact administrator.'
                        : resetTooltip
                    "
                    [disabled]="!field.editable"
                    [ngClass]="{ 'lightgray-icon': !field.editable }"
                    [style.visibility]="field.editable ? 'visible' : 'hidden'"
                  >
                    <mat-icon>refresh</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </form>

          <div *ngIf="!noEditableFieldsMessage" style="text-align: right; padding: 20px 10px 20px 20px; position: relative">
            <button mat-raised-button color="primary" (click)="onSaveAll()" [disabled]="isSaveDisabled()">
              <span style="display: flex; align-items: center; justify-content: center">
                <mat-spinner *ngIf="isSaving" diameter="20" style="margin-right: 8px"></mat-spinner>
                <mat-icon *ngIf="!isSaving" style="margin-right: 8px">save</mat-icon>
                {{ isSaving ? 'Saving...' : 'Save' }}
              </span>
            </button>
            <div
              *ngIf="getFormValidationMessage() || saveMessage"
              [ngClass]="getFormValidationMessage() ? 'error-message' : saveMessageClass"
              style="
                position: absolute;
                top: calc(100% - 20px);
                left: 50%;
                transform: translateX(-50%);
                white-space: nowrap;
              "
            >
              {{ getFormValidationMessage() || saveMessage }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
